export class AssetClassOptions {
    constructor(public equity: boolean,
                public fixedIncome: boolean,
                public liquidAlternative: boolean,
                public multiAsset: boolean,
                public cash: boolean) {
    }
}
